import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-required-miles.actions';
import { GetRequiredMilesState } from './get-required-miles.state';

/**
 * getRequiredMiles initial state
 */
export const getRequiredMilesInitialState: GetRequiredMilesState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetRequiredMiles Store
 */
export const getRequiredMilesReducerFeatures: ReducerTypes<GetRequiredMilesState, ActionCreator[]>[] = [
  on(actions.setGetRequiredMiles, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetRequiredMiles, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetRequiredMiles, () => getRequiredMilesInitialState),

  on(actions.cancelGetRequiredMilesRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetRequiredMiles, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetRequiredMilesFromApi, actions.updateGetRequiredMilesFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetRequiredMiles Store reducer
 */
export const getRequiredMilesReducer = createReducer(getRequiredMilesInitialState, ...getRequiredMilesReducerFeatures);
